import { defineMessages, useIntl } from "react-intl";
import { IconChevronRight } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { useLocaleNavigate } from "@ct-react/locale";
import Button from "../common/button";
import "./sale-box.scss";

const transDefs = defineMessages({
  title: { id: "article.sale-box.title", defaultMessage: "Vous souhaitez vendre votre propriété" },
  text: { id: "article.sale-box.text", defaultMessage: "Une équipe à votre service" },
  one: { id: "article.sale-box.reason-one", defaultMessage: "Expertise du marché" },
  two: { id: "article.sale-box.reason-two", defaultMessage: "Estimation personnalisée" },
  three: { id: "article.sale-box.reason-three", defaultMessage: "Publicité & affichage" },
  four: { id: "article.sale-box.reason-four", defaultMessage: "Communication digitale" },
  button: { id: "article.sale-box.button" , defaultMessage: "Estimation gratuite" }
})
type Props =  { className?: string, asWrapper?: boolean }

const SaleBoxPart = ({ className, asWrapper = false }: Props) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();
  const wrapperClasses = classNames("sale-box-part", className, { "as-wrapper": asWrapper });

  return (
    <div className={wrapperClasses}>
      <div className="inner">
        <h2>{`${intl.formatMessage(transDefs.title)} ?`}</h2>
        <p>{intl.formatMessage(transDefs.text)}</p>
        <ul>
          <li>{intl.formatMessage(transDefs.one)}</li>
          <li>{intl.formatMessage(transDefs.two)}</li>
          <li>{intl.formatMessage(transDefs.three)}</li>
          <li>{intl.formatMessage(transDefs.four)}</li>
        </ul>
        <Button className="white outline bold with-icon"
                onClick={() => navigate("with-us/estimate/")}>
          {intl.formatMessage(transDefs.button)}
          <IconChevronRight />
        </Button>
      </div>
    </div>);
};

export default SaleBoxPart;
